import List from './List/List';
import Cards from './Cards/Cards';
import Parchment from './Parchment/Parchment';
import Classic from './Classic/Classic';
import Centered from './Centered/Centered';
import Spotlight from './Spotlight/Spotlight';

const templates = {
  List,
  Cards,
  Parchment,
  Classic,
  Centered,
  Spotlight,
};

export default templates;
